import * as React from 'react';
import { SidebarTrigger } from '@/components/ui/sidebar';
import UserPanel from '@/components/layouts/user-panel';
import LogoIcon from '@/assets/logo.svg';

export default function Navbar() {
    return (
        <header className="flex flex-shrink-0 h-14 items-center gap-4 border-b border-neutral-650 bg-black px-4 lg:h-[60px] lg:px-6">
            <SidebarTrigger />
            <div className="flex-1">
                <a
                    href="#"
                    className="text-lg font-semibold hover:text-primary flex items-center gap-3"
                >
                    <LogoIcon height={28} width={32} viewBox="0 0 58 64" />
                    HyperFund AI
                </a>
            </div>
            <div className="flex items-center gap-4">
                <UserPanel />
            </div>
        </header>
    );
}
